/**
 * « Je n'étais pas en cours aujourd'hui » (SPEC §5).
 *
 * One tap, no justification asked, no follow-up question. The notification
 * regime is strict — parents are told when a day passes without work — but the
 * shell is not the place where that is argued. Declaring an absence suspends
 * the day's ritual; `notifier` decides the rest.
 */

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { queueSubmission } from "@/child/use-tutor-session";
import { Button, Card, Screen } from "@/ui/primitives";

export function AbsenceScreen() {
  const navigate = useNavigate();
  const [sent, setSent] = useState(false);

  const declare = async () => {
    const sessionId = sessionStorage.getItem("tuteur.session");
    await queueSubmission(sessionId, "absence", "[absence] Je n'étais pas en cours aujourd'hui.");
    setSent(true);
  };

  return (
    <Screen title="Pas cours aujourd'hui">
      <Card>
        {sent ? (
          <>
            <p>C'est noté. Le rituel du jour s'arrête là.</p>
            <Button onClick={() => navigate("/eleve")}>Revenir</Button>
          </>
        ) : (
          <>
            <p>Tu n'étais pas en cours ? Dis-le, et on n'en parle plus aujourd'hui.</p>
            <Button onClick={() => void declare()}>Je n'étais pas en cours</Button>
          </>
        )}
      </Card>
    </Screen>
  );
}
